import { useEffect, useState } from 'react';
import { ProjectAnalysisDivisionDrawsDTO } from './project-analysis.type';
import { ProjectDraw } from '../project/project.type';
import { handleError } from '../../common/utils/util.errors';
import { getProjectDivisionDraws } from '../project/project.api';

interface SelectedProjectDraws {
  [divisionId: string]: string[];
}
const useProjectDivisionsDraws = (projectId: string) => {
  const [selectedProjectDraws, setSelectedProjectDraws] = useState<SelectedProjectDraws>({});

  const handleProjectDrawSelectionChange = (divisionId: string, newSelectedProjectDraws: string[]) => {
    setSelectedProjectDraws({ ...selectedProjectDraws, [divisionId]: newSelectedProjectDraws });
    ``;
  };

  useEffect(() => {
    getProjectDivisionDraws(projectId)
      .then((response: ProjectAnalysisDivisionDrawsDTO) => {
        const initialSelectedProjectDraws: SelectedProjectDraws = {};

        for (const divisionId in response) {
          initialSelectedProjectDraws[divisionId] = response[divisionId].map((draw: ProjectDraw) => draw.id);
        }

        setSelectedProjectDraws(initialSelectedProjectDraws);
      })
      .catch(error => {
        handleError('Error fetching division draws!');
        console.error('Error fetching division draws:', error);
      });
  }, [projectId]);

  return { selectedProjectDraws, handleProjectDrawSelectionChange };
};

export default useProjectDivisionsDraws;
